import { useState } from 'react';

export const useBulkOrderFilters = () => {
  const [itemSearch, setItemSearch] = useState<string>('');
  const [category, setCategory] = useState<number>(-1);
  const [appliedItemSearch, setAppliedItemSearch] = useState<string>('');
  const [appliedCategory, setAppliedCategory] = useState<number>(-1);

  const handleSearch = () => {
    setAppliedItemSearch(itemSearch);
    setAppliedCategory(category);
  };

  const clearFilters = () => {
    setItemSearch('');
    setCategory(-1);
    setAppliedItemSearch('');
    setAppliedCategory(-1);
  };

  return {
    itemSearch,
    setItemSearch,
    category,
    setCategory,
    appliedItemSearch,
    appliedCategory,
    handleSearch,
    clearFilters,
  };
};
